var prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
  window.addEventListener('scroll', function () {
    var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;
    var sticky = $('.sticky');
    var announcement_bar = $('.announcement-bar');
    if (prevScrollPos > currentScrollPos) {
      sticky.addClass("fixed")
      if(currentScrollPos < 30) {
        announcement_bar.removeClass("fixed");
        sticky.removeClass("fixed");
      }
    } else {
      if(currentScrollPos > 30) {
        announcement_bar.addClass("fixed")
        sticky.removeClass("fixed")
        
      }
    }
    prevScrollPos = currentScrollPos;
   
  });

$(".wrap-first-word:not(.plp)").html(function () {
  var text = $(this).text().trim().split(" ");
  var first = text.shift();
  return (text.length > 0 ? "<span class='first-word'>" + first + "</span> " : first) + text.join(" ");
});

$('.grid__item').each(function () {
  $(this).find('.grid-btn').click(function () {
    setTimeout(function () {
      $('body .mini-cart').addClass("cart-drawer");
      $("body, html").addClass("cart-drawer--open")
    }, 1000);
  });
});



// blog page funcionality
if ($('.main-blog').length) {

  var wW = $(window).width();
  var size = 3;
  var divs = $('.main-blog').find(".blog-articles > div");

  if (wW > 768) {
    size = size * 2;
  } else if (wW <= 768) {
    size = 4;
  }

  for (var i = 0; i < divs.length; i += size) {
    divs.slice(i, i + size).wrapAll("<div class='blog-articles-wrapp'></div>");
  }
  //     }).resize();
  $.each($('.blog-articles .blog-articles-wrapp'), function (i, l) {
    if ($(this).find(".article").length < size / 2) {
      $(this).addClass('start');
    }
  });

  $('.main-blog').find('.blog-articles-wrapp .tag-image').click(function (e) {
    $('.open-articles').removeClass('open');
    $(this).next('.open-articles').addClass('open');
    $(this).siblings('.tag-image').removeClass('active');
    $(this).parent().siblings('.blog-articles-wrapp').find('.tag-image').removeClass('active');
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.open-articles').removeClass('open');
    } else {
      $(this).addClass('active');
    }

  });



}